import { User as FirestoreUser } from '@angular/fire/auth';
import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { tap, map, shareReplay } from 'rxjs';
import { User } from './user';
import { CapicheLoggerService } from 'capiche-logger';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  logger = new CapicheLoggerService('user.service:', false);

  /** Public stream for components/services to consume */
  currentUser$ = this.authService.authState$.pipe(
    tap((firestoreUser: FirestoreUser | null) => {
      this.logger.log('this.authService.authState$:', firestoreUser?.uid);
    }),
    map((firestoreUser) => (firestoreUser ? new User(firestoreUser) : null)),
    shareReplay(1), // optional: prevents double-subscription churn
  );

  constructor(private authService: AuthService) {
    this.logger.log('constructor');
  }
}
